/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = {
  value23: "",
  value24: "",
  value25: "",
  value26: "",
  value27: "",
  value28: "",
  value29: "",
};

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value } = values;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số tiền
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                1
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", background: "#ddeff3" }}>
                Tổng doanh thu phát sinh trong kỳ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                [23]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right" }}>
                <InputTable name="value23" value={data.value23} onChange={handleChange} />
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                2
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", background: "#ddeff3" }}>
                Tổng doanh thu tính thuế
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                [24]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right" }}>
                <InputTable name="value24" value={data.value24} onChange={handleChange} />
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                3
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", background: "#ddeff3" }}>
                Tổng số thuế GTGT phải nộp
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                [25]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right" }}>
                <InputTable name="value25" value={data.value25} onChange={handleChange} />
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                4
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", background: "#ddeff3" }}>
                Tổng số thuế TNCN phát sinh trong kỳ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                [26]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right" }}>
                <InputTable name="value26" value={data.value26} onChange={handleChange} />
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                5
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left" }}>
                Tiền phạt, bồi thường mà bên cho thuê nhận được theo thỏa thuận tại hợp đồng (nếu
                có)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                [27]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right" }}>
                <InputTable name="value27" value={data.value27} onChange={handleChange} />
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                6
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", background: "#ddeff3" }}>
                Tổng số thuế TNCN phải nộp từ nhận tiền phạt, bồi thường (nếu có)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                [28]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                7
              </Td>
              <Td rowSpan={1} style={{ textAlign: "left", background: "#ddeff3" }}>
                Tổng số thuế TNCN phải nộp [29]=[26]+[28]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                [29]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
